import { render, staticRenderFns } from "./FolhasObraModule.vue?vue&type=template&id=72773d58&scoped=true&"
import script from "./FolhasObraModule.vue?vue&type=script&lang=js&"
export * from "./FolhasObraModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72773d58",
  null
  
)

export default component.exports